import { DoubleFuelDataResolved } from './double-fuel-data-resolved';

export interface UpdateDoubleFuelDataResolvedRequest {
  dataToUpdate: DoubleFuelDataResolved[];
}
